module.exports = __webpack_public_path__ + "img/mid.2515eb6.svg";